import s from './Filters.module.css';
import type { TTaskStatus } from '../data/types';

export type TStatusFilter = TTaskStatus | 'all';

interface IFiltersProps {
  status: TStatusFilter;
  onStatusChange: (s: TStatusFilter) => void;
  search: string;
  onSearchChange: (s: string) => void;
}

const STATUSES: Array<{ key: TStatusFilter; label: string; mod?: string }> = [
  { key: 'all', label: 'Все' },
  { key: 'done', label: 'Готово', mod: 'statusDone' },
  { key: 'in_progress', label: 'В работе', mod: 'statusProgress' },
  { key: 'todo', label: 'Не начато' },
];

export const Filters = ({ status, onStatusChange, search, onSearchChange }: IFiltersProps) => (
  <div className={s.bar}>
    <input
      className={s.search}
      placeholder="Поиск по задачам..."
      value={search}
      onChange={(e) => onSearchChange(e.target.value)}
      aria-label="Поиск"
    />
    <span className={s.divider} />
    {STATUSES.map((st) => {
      const isActive = status === st.key;
      const cls = `${s.chip} ${st.mod ? s[st.mod] : ''} ${isActive ? s.active : ''}`.trim();
      return (
        <button key={st.key} type="button" className={cls} onClick={() => onStatusChange(st.key)}>
          <span className={s.dot} />
          {st.label}
        </button>
      );
    })}
  </div>
);
